// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3717":"css/admin-app.7022","4814":"css/app.7022"}[chunkId] + ".css";
};